const config = {
    apiBaseUrl:
        process.env.REACT_APP_API_URL ||
        'https://5bnu3oi26m.execute-api.us-east-1.amazonaws.com/prod',
};

export default config;
